import { onMounted, onUnmounted, ref } from 'vue'
import { isiOS } from '@/utils/is'

let oldContentWeight = 0

// 封装设置定时器的函数
function useTimeout(callback: Fn) {
  const interval = ref()

  const deleteInterval = () => {
    if (interval.value) {
      clearInterval(interval.value)
      interval.value = null
    }
  }

  const initInterval = () => {
    deleteInterval()
    interval.value = setInterval(() => {
      callback()
    }, 300)
  }

  const start = () => {
    callback()
    if (isiOS()) {
      initInterval()
    } else {
      window.addEventListener('resize', callback)
    }
  }

  const stop = () => {
    if (isiOS()) {
      deleteInterval()
    } else {
      window.removeEventListener('resize', callback)
    }
  }

  onMounted(() => {
    start()
  })

  onUnmounted(() => {
    stop()
  })
}

const setWindowRem = (isSwitch: boolean, cb?: Function) => {
  if (oldContentWeight !== window.innerWidth) {
    console.log('oldContentWeight', oldContentWeight)
    const contentWeight = window.innerWidth
    oldContentWeight = window.innerWidth
    const ratio = contentWeight / 375
    document.documentElement.style.fontSize = isSwitch ? ((16 * ratio) + 'px') : '16px'
    if (cb) {
      cb()
    }
  }
}

export function autoRem(isSwitch: boolean, cb?: Function) {
  useTimeout(() => {
    setWindowRem(isSwitch, cb)
  })
}

export const pxToRem = (pxValue: string | number | undefined, rootFontSize = 16) => {
  if (pxValue) {
    const valueAsString = typeof pxValue === 'number' ? String(pxValue) : pxValue
    const regex = /(\d*\.?\d+)(px)?/i
    const match = valueAsString.match(regex)
    if (match) {
      const valueInPx = parseFloat(match[1])
      return `${valueInPx / rootFontSize}rem`
    } else {
      return valueAsString
    }
  } else {
    return ''
  }
}
